module.exports = __webpack_public_path__ + "static/media/sergepoppes.0b90909f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/sergepoppes.webp
// module id = 480
// module chunks = 0